//@flow
import React from 'react';
import './styles.scss';
import { Image } from 'components/atoms/image';
import { NumberUtil } from 'utils/NumberUtil';

type Props = {
  data: {
    text: string,
    value: string,
    priority: number,
    src: string,
  },
};

export const ProductAreaText = (props: Props) => {
  const { data } = props;
  const CustomTag = `h${data.priority}`;
  const renderText = () => {
    if (data.text) {
      return data.text;
    } else {
      return <img src={data.src} alt={'icons'} style={{ height: '18px' }} />;
    }
  };

  return (
    <div className={'area-text-section'}>
      <span>{renderText()}</span>
      <CustomTag>{data.value}</CustomTag>
      {data.text && <p>&nbsp;&nbsp;sq.feet</p>}
    </div>
  );
};
